import React, { useContext } from 'react';
import clsx from 'clsx';
import { Link } from 'gatsby';
import authenticationCtx from 'context/authentication';
import useHasMounted from 'hooks/useHasMounted';

// Inline SVG icons (stroke-based, currentColor) so they invert with button state.
const iconProps = {
	className: 'h-7 w-7',
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 1.8,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
	viewBox: '0 0 24 24',
};

const ICONS = {
	dashboard: (
		<svg {...iconProps}>
			<rect x="3" y="3" width="7" height="9" rx="1" />
			<rect x="14" y="3" width="7" height="5" rx="1" />
			<rect x="14" y="12" width="7" height="9" rx="1" />
			<rect x="3" y="16" width="7" height="5" rx="1" />
		</svg>
	),
	strategies: (
		<svg {...iconProps}>
			<path d="M12 3 3 7.5 12 12l9-4.5L12 3Z" />
			<path d="m3 12 9 4.5L21 12" />
			<path d="m3 16.5 9 4.5 9-4.5" />
		</svg>
	),
	ranking: (
		<svg {...iconProps}>
			<path d="M5 21V11" />
			<path d="M12 21V4" />
			<path d="M19 21v-7" />
		</svg>
	),
	simulators: (
		<svg {...iconProps}>
			<line x1="4" y1="6" x2="20" y2="6" />
			<line x1="4" y1="12" x2="20" y2="12" />
			<line x1="4" y1="18" x2="20" y2="18" />
			<circle cx="9" cy="6" r="2" />
			<circle cx="15" cy="12" r="2" />
			<circle cx="8" cy="18" r="2" />
		</svg>
	),
	profile: (
		<svg {...iconProps}>
			<circle cx="12" cy="8" r="4" />
			<path d="M4 21a8 8 0 0 1 16 0" />
		</svg>
	),
};

const BUTTON_DEFS = [
	{ url: '/dashboard', icon: 'dashboard', label: 'dashboard' },
	{ url: '/strategies', icon: 'strategies', label: 'strategies' },
	{ url: '/rankings', icon: 'ranking', label: 'ranking' },
	{ url: '/simulators', icon: 'simulators', label: 'simulators' },
	{
		url: '/profile',
		icon: 'profile',
		label: 'profile',
		// the profile submenu pages should keep the "profile" button pressed
		matchPaths: ['/password', '/settings', '/trading-configuration'],
	},
];

const MobileNavigation = () => {
	const hasMounted = useHasMounted();
	const { isLoggedIn } = useContext(authenticationCtx);

	if (!hasMounted || !isLoggedIn) {
		return null;
	}

	return (
		<nav className="md:hidden w-full shrink-0 bg-black-42 pb-[env(safe-area-inset-bottom)]">
			<div className="flex w-full flex-row border-t border-white">
				{BUTTON_DEFS.map(({ url, icon, label, matchPaths = [] }, i) => {
					const baseClass = clsx('btn btn-mobile-menu flex-1 flex flex-col !rounded-none gap-1 py-2', {
						'border-l border-white/30': i > 0,
					});
					const getProps = ({ location }) => {
						const path = location.pathname.replace(/\/+$/, '');
						const active = path === url || matchPaths.includes(path);
						return { className: clsx(baseClass, { 'btn-pressed': active }) };
					};
					return (
						<Link to={url} key={url} getProps={getProps} className={baseClass}>
							<span className="mx-auto">{ICONS[icon]}</span>
							<span className="text-xxxs capitalize">{label}</span>
						</Link>
					);
				})}
			</div>
		</nav>
	);
};

export default MobileNavigation;
